<template>
  <section id="cafe" class="cafe">
    <!-- タイトル・サブタイトル -->
    <div class="text-wrapper">
      <h1 class="title">{{ $t('page.cafe.title') }}</h1>
      <div class="sub-title" v-html="$t('page.cafe.sub-title')"></div>
    </div>

    <!-- トップ画像 -->
    <div class="top-content">
      <div class="top-visual">
        <img class="image" src="~/assets/pages/cafe/ImageCafe.webp" alt="" />
      </div>
    </div>

    <!-- メインコンテンツ -->
    <div class="main-content">
      <div class="row">
        <div class="sub-text">
          <p
            v-for="(text, index) in $tm('page.cafe.cafe-content.texts')"
            v-html="$rt(text)"
            class="text"
            :key="index"
          />
        </div>
      </div>
      <div class="row-2">
        <div class="sub-text-2">
          <p
            v-for="(text, index) in $tm('page.cafe.cafe-content-2.texts')"
            v-html="$rt(text)"
            class="text"
            :key="index"
          />
        </div>
        <!-- 画像ボックス -->
        <div class="sub-visual-box">
          <div class="sub-visual-box-left">
            <img class="image" src="~/assets/pages/cafe/ImageCafeFeature01.webp" alt="" />
          </div>
          <div class="sub-visual-box-center">
            <img class="image" src="~/assets/pages/cafe/ImageCafeFeature02.webp" alt="" />
          </div>
          <div class="sub-visual-box-right">
            <img class="image" src="~/assets/pages/cafe/ImageCafeFeature03.webp" alt="" />
            <img class="image" src="~/assets/pages/cafe/ImageCafeFeature04.webp" alt="" />
          </div>
        </div>
      </div>
      <div class="background" />
      <div class="mask" />

      <!-- 注意事項 -->
      <div class="attention-wrapper">
        <div class="attention">
          <p v-html="$rt($t('page.cafe.attention'))" />
        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts"></script>
<style lang="scss" scoped>
@use '@/assets/styles/mixins' as m;
@use '@/assets/styles/variables' as v;
@use '@/assets/styles/util' as u;

#cafe {
  width: 100%;
  text-align: center;
  background: v.$common-white-color;
  padding-top: 120px;
  @include m.sp() {
    padding-top: 64px;
  }
}

.text-wrapper {

  .title {
    color: v.$accent-color;
    font-size: 1.125rem;
    font-family: v.$accent-font-family;
    font-weight: v.$font-weight-light;
    margin: 0;
    @include m.sp() {
      font-size: 1rem;
      letter-spacing: 6.4px;
    }
  }

  .sub-title {
    color: v.$text-title-color;
    font-size: 1.375rem;
    line-height: 1.5;
    word-break: keep-all;
    @include m.sp() {
      font-size: 1.25rem;
      letter-spacing: 3px;
    }
  }
}

.top-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 96px auto 128px;
  max-width: 1280px;
  @include m.sp() {
    margin: 64px auto 0;
    padding: 0;
  }

  .top-visual {
    display: flex;
    place-content: center;
    justify-content: right;
    @include m.sp() {
      padding: 0;
    }
  }
}

.main-content {
  width: 100%;
  position: relative;
  padding: 99px 0 170px 0;
  align-items: center;
  @include m.sp() {
    padding: 64px 0;
  }

  .background {
    position: absolute;
    inset: 0;
    background: v.$bg-accent1-color;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    height: 100%;
    width: 100%;
    z-index: 0;
  }

  .mask {
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 1;
    background: url(~/assets/pages/common/BgTexture01.webp) center/cover no-repeat;
    opacity: 0.08;
    mix-blend-mode: multiply;
  }

  .title,
  .subject,
  .text,
  .main-visual,
  .sub-visual-box,
  .attention {
    position: relative;
    z-index: 2;
  }

  .row {
    display: flex;
    max-width: calc(1280px + 6%);
    padding: 0 3%;
    margin: 0 auto;
    .main-visual {
      max-width: 520px;
      align-content: center;
      @include m.sp() {
        max-width: 144px;
        margin: 0 auto;
      }
    }
  }

  .row-2 {
    display: flex;
    max-width: calc(1280px + 6%);
    padding: 0 3%;
    margin: 160px auto 0;
    @include m.sp() {
      margin: 32px auto 0;
    }
  }

  .title {
    flex-wrap: wrap;
    font-size: 1.125rem;
    height: 100%;
    align-content: center;
    font-family: v.$accent-font-family;
    font-weight: v.$font-weight-light;
    color: v.$text-title-color;
    padding-bottom: 61px;
    letter-spacing: 7.2px;
  }

  .sub-text {
    width: 640px;
    text-align: center;
    align-content: center;
    margin: 0 auto;
    word-break: keep-all;
    @include m.sp() {
      text-align: center;
      padding-left: 0;
    }

    /* 主題 */
    .subject {
      font-size: 1.5rem;
      @include m.sp() {
        font-size: 1.25rem;
      }
    }

    .text {
      font-size: 1rem;
      margin-top: 57px;
      line-height: 2.4;
      @include m.sp() {
        font-size: 0.875rem;
        margin-top: 32px;
      }
    }

    :deep(span) {
      white-space: nowrap;
    }
  }

  .sub-text-2 {
    text-align: left;
    align-content: center;
    @include m.sp() {
      text-align: center;
      padding-left: 0;
    }

    .text {
      font-size: 1rem;
      line-height: 2.4;
      @include m.sp() {
        font-size: 0.875rem;
      }
    }
  }

  .sub-visual-box {
    display: flex;
    @include m.sp() {
      margin-left: 0;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: auto auto;
      gap: 16px;
      width: 100%;
    }

    .sub-visual-box-left {
      flex: 1;
      display: flex;
      @include m.sp() {
        display: initial;
        grid-column: 1 / 2;
        grid-row: 1 / 2;
      }
    }

    .sub-visual-box-center {
      flex: 1;
      margin-left: 16px;
      display: flex;
      @include m.sp() {
        display: initial;
        grid-column: 2 / 3;
        grid-row: 1 / 2;
        margin-left: 0;
      }
    }

    .sub-visual-box-right {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 16px;
      margin-left: 16px;
      @include m.sp() {
        flex: none;
        flex-direction: row;
        margin-left: 0;
      }
    }

    .sub-visual-box-left .image,
    .sub-visual-box-center .image,
    .sub-visual-box-right .image {
      @include m.sp() {
        width: 100%;
        height: auto;
        object-fit: cover;
      }
    }
  }

  .attention-wrapper {
    margin: 0 auto;
    max-width: calc(1280px + 6%);
    padding: 0 3%;

    .attention {
      max-width: 1280px;
      font-size: 0.875rem;
      color: v.$text-base-color;
      line-height: 2.4;
      border: solid 1px v.$common-element-color;
      margin: 64px auto 0;
      padding: 40px 80px;
      @include m.sp() {
        font-size: 0.8125rem;;
        margin: 32px 16px 0;
        padding: 0 16px;
      }

      p {
        text-align: left;
      }
    }
  }
}
</style>
